export default __webpack_public_path__ + "static/vr-logo-01-92f6cabf2ddf3521f63168e56293fb3d.png";